import ApiConstants from "../../Globals/ApiConstants"

function getListAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_LIST_LOAD,
        payload
    }
    return action
}

function createCustomerAction(payload: any) {
    const action = {
        type: ApiConstants?.API_CREATE_CUSTOMER_LOAD,
        payload
    }
    return action
}
function mergeCustomerAction(payload: any) {
    const action = {
        type: ApiConstants?.API_MERGE_CUSTOMER_LOAD,
        payload
    }
    return action
}
function setCustomerCreditLimitAction(payload: any) {
    const action = {
        type: ApiConstants?.API_SET_CUSTOMER_CREDIT_LIMIT_LOAD,
        payload
    }
    return action
}
function addCustomerCreditOpeningBalanceAction(payload: any) {
    const action = {
        type: ApiConstants?.API_ADD_CUSTOMER_CREDIT_OPENING_BALANCE_LOAD,
        payload
    }
    return action
}
function recordCustomerCreditSettlementAction(payload: any) {
    const action = {
        type: ApiConstants?.API_RECORD_CUSTOMER_CREDIT_SETTLEMENT_LOAD,
        payload
    }
    return action
}
function getCustomerCreditLedgerAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_CUSTOMER_CREDIT_LEDGER_LOAD,
        payload
    }
    return action
}
function createCycleCountAction(payload: any) {
    const action = {
        type: ApiConstants?.API_CREATE_CYCLE_COUNT_LOAD,
        payload
    }
    return action
}

function updateProductItemColorAndSizeAction(payload: any) {
    const action = {
        type: ApiConstants?.API_UPDATE_PRODUCT_ITEM_COLOR_AND_SIZE_LOAD,
        payload
    }
    return action
}

function addProductAction(payload: any) {
    const action = {
        type: ApiConstants?.API_ADD_PRODUCT_LOAD,
        payload
    }
    return action
}

function categoryAndSubCategoryListAction(payload: any) {
    const action = {
        type: ApiConstants?.API_CATEGORY_AND_SUBCATEGORY_LIST_LOAD,
        payload
    }
    return action
}

function updateProductStatusAction(payload: any) {
    const action = {
        type: ApiConstants?.API_UPDATE_PRODUCT_STATUS_LOAD,
        payload
    }
    return action;
}

function updateStickeringStatusAction(payload: any) {
    const action = {
        type: ApiConstants?.API_UPDATE_STICKERING_LOAD,
        payload
    }
    return action;
}

function getProductListAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_PRODUCT_LIST_LOAD,
        payload
    }
    return action
}

function getCustomerListAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_CUSTOMER_LIST_LOAD,
        payload
    }
    return action
}

function getReferenceDataAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_REFERENCE_DATA_LOAD,
        payload
    }
    return action
}

function getUpcomingCustomerEventsAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_UPCOMING_CUSTOMER_EVENTS_LOAD,
        payload
    }
    return action
}

function getProductItemAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_PRODUCT_ITEM_LOAD,
        payload
    }
    return action
}

function createBillAction(payload: any) {
    const action = {
        type: ApiConstants?.API_CREATE_BILL_LOAD,
        payload
    }
    return action
}

function createBillV2Action(payload: any) {
    const action = {
        type: ApiConstants?.API_CREATE_BILL_V2_LOAD,
        payload
    }
    return action
}

function getBillingListAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_BILLING_LIST_LOAD,
        payload
    }
    return action
}
// Same getBillingList query as getBillingListAction, but kept on its own
// action/reducer slice (billNavigationRow) so probing a single invoiceId for
// Prev/Next (useBillNavigation) never clobbers the Customer Bills table's own
// list state.
function getBillNavigationRowAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_BILL_NAVIGATION_ROW_LOAD,
        payload
    }
    return action
}
function getCycleCountListAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_CYCLE_COUNT_LIST_LOAD,
        payload
    }
    return action
}

function createOrUpdateCycleCountAction(payload: any) {
    const action = {
        type: ApiConstants?.API_CREATE_OR_UPDATE_CYCLE_COUNT_LOAD,
        payload
    }
    return action;
}

function getStockMovementHistoryAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_STOCK_MOVEMENT_HISTORY_LOAD,
        payload
    }
    return action
}

function getStockHistoryAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_STOCK_HISTORY_LOAD,
        payload
    }
    return action
}

function adminAdjustStockAction(payload: any) {
    const action = {
        type: ApiConstants?.API_ADMIN_ADJUST_STOCK_LOAD,
        payload
    }
    return action
}

function getComboComponentOptionsAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_COMBO_COMPONENT_OPTIONS_LOAD,
        payload
    }
    return action
}

function getComboItemsAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_COMBO_ITEMS_LOAD,
        payload
    }
    return action
}
function cycleCountListSearchAction(payload: any) {
    const action = {
        type: ApiConstants?.API_CYCLE_COUNT_LIST_SEARCH_LOAD,
        payload
    }
    return action;
}

function clearProductItemListAction() {
    const action = {
        type: ApiConstants?.CLEAR_PRODUCT_ITEM_LIST
    }
    return action
}

function removedProductListAction(payload: any) {
    const action = {
        type: ApiConstants?.REMOVED_PRODUCT_ITEM_LIST,
        payload
    }
    return action
}

function updateProductListAction(payload: any) {
    const action = {
        type: ApiConstants?.UPDATE_PRODUCT_ITEM_LIST,
        payload
    }
    return action
}

function apparelLoginAction(payload: any) {
    const action = {
        type: ApiConstants?.API_APPAREL_LOGIN_LOAD,
        payload
    }
    return action
}

function sendLoginOtpAction(payload: any) {
    const action = {
        type: ApiConstants?.API_SEND_LOGIN_OTP_LOAD,
        payload
    }
    return action
}

function verifyLoginOtpAction(payload: any) {
    const action = {
        type: ApiConstants?.API_VERIFY_LOGIN_OTP_LOAD,
        payload
    }
    return action
}

function clearLoginOtpStateAction() {
    const action = {
        type: ApiConstants?.CLEAR_LOGIN_OTP_STATE
    }
    return action
}

function getCustomerHistoryAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_CUSTOMER_HISTORY_LOAD,
        payload
    }
    return action
}

function getEmployeeSalesHistoryAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_EMPLOYEE_SALES_HISTORY_LOAD,
        payload
    }
    return action
}

function getProductHistoryAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_PRODUCT_HISTORY_LOAD,
        payload
    }
    return action;
}

function getInvoiceDetailsAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_INVOICE_DETAILS_LOAD,
        payload
    }
    return action;
}

function getBarcodeZipFile(data: any) {
    const action = {
        type: ApiConstants?.GET_BARCODE_ZIP_FILE,
        data
    }
    return action;
}

function updateMultipleInventoryAction(payload: any) {
    const action = {
        type: ApiConstants?.API_UPDATE_MULTIPLE_INVENTORY_LOAD,
        payload
    }
    return action;
}

function getMultipleInventoryCountsAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_MULTIPLE_INVENTORY_COUNT_LOAD,
        payload
    }
    return action;
}

function getMultipleInventorySoldListAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_MULTIPLE_INVENTORY_SOLD_LIST_LOAD,
        payload
    }
    return action;
}

function getMultipleInventoryDamagedListAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_MULTIPLE_INVENTORY_DAMAEGED_LIST_LOAD,
        payload
    }
    return action;
}

function getCategorySubCategoryListAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_CATEGORY_SUBCATEGORY_LIST_LOAD,
        payload
    }
    return action;
}

function getProductListByCategory(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_PRODUCT_LIST_CATEGORY_LIST_LOAD,
        payload
    }
    return action;
}

function getupdateCycleCountProductStatus(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_UPDATE_CYCLE_COUNT_LOAD,
        payload
    }
    return action
}

function updateCycleCountAction(payload: any) {
    const action = {
        type: ApiConstants?.API_UPDATE_CYCLE_COUNT_LIST_LOAD,
        payload
    }
    return action
}

function getMultipleInventoryScrapListAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_MULTIPLE_SCRAP_LIST_LOAD,
        payload
    }
    return action
}

function getCycleCountReportAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_CYCLE_COUNT_REPORT_LOAD,
        payload
    }
    return action
}

function getReportListAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_REPORT_LIST_LOAD,
        payload
    }
    return action
}

function getVendorListAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_VENDOR_LIST_LOAD,
        payload
    }
    return action
}

function createOrUpdateVendorAction(payload: any) {
    const action = {
        type: ApiConstants?.API_CREATE_OR_UPDATE_VENDOR_LOAD,
        payload
    }
    return action
}

function getVendorEmailValidationAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_VENDOR_EMAIL_VALIDATION_LOAD,
        payload
    }
    return action
}

function clearSelectAction() {
    const action = {
        type: ApiConstants?.CLEAR_SELECT_LOAD
    }
    return action
}

function vendorDropDownListAction() {
    const action = {
        type: ApiConstants?.VENDOR_DROP_DOWN_LIST_LOAD
    }
    return action
}

function getVendorPurchaseListAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_VENDOR_PURCHASE_LIST_LOAD,
        payload
    }
    return action
}

function getRentalListAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_RENTAL_LIST_LOAD,
        payload
    }
    return action
}

function createOrUpdateRentalAction(payload: any) {
    const action = {
        type: ApiConstants?.API_CREATE_OR_UPDATE_RENTAL_LOAD,
        payload
    }
    return action
}

function createOrUpdateVendorPurchaseAction(payload: any) {
    const action = {
        type: ApiConstants?.API_CREATE_OR_UPDATE_VENDOR_PURCHASE_LOAD,
        payload
    }
    return action
}

function getVendorPurchaseHistoryAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_VENDOR_PURCHASE_HISTORY_LOAD,
        payload
    }
    return action
}

function getVendorDebtLedgerAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_VENDOR_DEBT_LEDGER_LOAD,
        payload
    }
    return action
}

function createVendorDebtEntryAction(payload: any) {
    const action = {
        type: ApiConstants?.API_CREATE_VENDOR_DEBT_ENTRY_LOAD,
        payload
    }
    return action
}

function mrpListAction() {
    const action = {
        type: ApiConstants?.MRP_LIST_LOAD
    }
    return action
}

function getEmployeeListAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_EMPLOYEE_LIST_LOAD,
        payload
    }
    return action
}

function createOrUpdateEmployeeAction(payload: any) {
    const action = {
        type: ApiConstants?.API_CREATE_OR_UPDATE_EMPLOYEE_LOAD,
        payload
    }
    return action
}

function employeeDropDownListAction() {
    const action = {
        type: ApiConstants?.EMPLOYEE_DROP_DOWN_LIST_LOAD
    }
    return action
}

function createOrUpdateProcurementAction(payload: any) {

    const action = {
        type: ApiConstants?.API_CREATE_OR_UPDATE_PROCUREMENT_LOAD,
        payload
    }
    return action
}

function getProcurementAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_PROCUREMENT_LIST_LOAD,
        payload
    }
    return action
}

function getProcurementExportListAction() {
    const action = {
        type: ApiConstants?.API_GET_PROCUREMENT_EXPORT_LIST_LOAD,
    }
    return action
}

function getAuditLogListAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_AUDIT_LOG_LIST_LOAD,
        payload
    }
    return action
}


function createOrUpdateAttachmentAction(payload: any) {
    const action = {
        type: ApiConstants?.API_CREATE_OR_UPDATE_ATTACHMENT_LOAD,
        payload
    }
    return action
}

function getAttachmentAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_ATTACHMENT_LOAD,
        payload
    }
    return action
}

function getVendorBillAttachmentAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_VENDOR_BILL_ATTACHMENT_LOAD,
        payload
    }
    return action
}

function getVendorDebtAttachmentAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_VENDOR_DEBT_ATTACHMENT_LOAD,
        payload
    }
    return action
}

function getSalesReturnAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_SALES_RETURN_LIST_LOAD,
        payload
    }
    return action
}

function createOrUpdateSalesReturnAction(payload: any) {
    const action = {
        type: ApiConstants?.API_CREATE_OR_UPDATE_SALES_RETURN_LOAD,
        payload
    }
    return action
}

function getSalesReturnBasedOnProductIdAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_SALES_RETURN_BASED_ON_PRODUCT_ID_LOAD,
        payload
    }
    return action
}

function clearSalesReturnBasedOnProductIdAction(payload: any) {
    const action = {
        type: ApiConstants?.API_CLEAR_SALES_RETURN_BASED_ON_PRODUCT_ID_SUCCESS,
        payload
    }
    return action
}

function getSalesReturnBillDetailsAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_SALES_RETURN_BILL_DETAILS_LOAD,
        payload
    }
    return action
}

function addCategoryAction(payload: any) {
    const action = {
        type: ApiConstants?.API_ADD_CATEGORY_ON_LOAD,
        payload
    }
    return action
}

function createOrUpdateBannerAction(payload: any) {
    const action = {
        type: ApiConstants?.API_CREATE_UPDATE_BANNER_LOAD,
        payload
    }
    return action;
}

function addSubCategoryAction(payload: any) {
    const action = {
        type: ApiConstants?.API_ADD_SUB_CATEGORY_ON_LOAD,
        payload
    }
    return action
}

function getBannerMetaAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_BANNER_LOAD,
        payload
    }
    return action;
}

function getBannerAttachmentAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_BANNER_ATTACHMENT_LOAD,
        payload
    }
    return action;
}

function getHotNewTopPickAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_HOT_NEW_TOP_PICK_LOAD,
        payload
    }
    return action;
}

function updateHotNewTopPickAction(payload: any) {
    const action = {
        type: ApiConstants?.API_UPDATE_HOT_NEW_TOP_PICK_LOAD,
        payload
    }
    return action;
}

function getOnlineOrderAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_ONLINE_ORDER_LOAD,
        payload
    }
    return action;
}

function updateOnlineOrderAction(payload: any) {
    const action = {
        type: ApiConstants?.API_UPDATE_ONLINE_ORDER_LOAD,
        payload
    }
    return action;
}

function getCoreCategoryMetaAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_CORE_CATEGORY_META_LOAD,
        payload
    }
    return action;
}

function updateItemQuantity(payload: any) {
    const action = {
        type: ApiConstants.UPDATE_PRODUCT_ITEM_QUANTITY,
        payload
    }
    return action
};

function getDashboardDataAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_DASHBOARD_DATA_LOAD,
        payload
    }
    return action;
}

function getTopProductsAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_TOP_PRODUCTS_LOAD,
        payload
    }
    return action;
}

function getTopCustomersAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_TOP_CUSTOMERS_LOAD,
        payload
    }
    return action;
}

function getSalesDashboardDataAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_SALES_DASHBOARD_DATA_LOAD,
        payload
    }
    return action;
}

function getAttendanceListAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_ATTENDANCE_LIST_LOAD,
        payload
    }
    return action;
}

function getEmployeeAttendanceCalendarAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_EMPLOYEE_ATTENDANCE_CALENDAR_LOAD,
        payload
    }
    return action;
}

function getEmployeeAttendanceSummaryAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_EMPLOYEE_ATTENDANCE_SUMMARY_LOAD,
        payload
    }
    return action;
}

function getAttendanceRecordByIdAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_ATTENDANCE_RECORD_BY_ID_LOAD,
        payload
    }
    return action;
}

function markAttendanceAction(payload: any) {
    const action = {
        type: ApiConstants?.API_MARK_ATTENDANCE_LOAD,
        payload
    }
    return action;
}

function getInventoryDashboardDataAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_INVENTORY_DASHBOARD_DATA_LOAD,
        payload
    }
    return action;
}

function getCustomerDashboardDataAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_CUSTOMER_DASHBOARD_DATA_LOAD,
        payload
    }
    return action;
}

function getVendorDashboardDataAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_VENDOR_DASHBOARD_DATA_LOAD,
        payload
    }
    return action;
}

function getCustomerCreditDashboardDataAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_CUSTOMER_CREDIT_DASHBOARD_DATA_LOAD,
        payload
    }
    return action;
}

function getVendorDebtDashboardDataAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_VENDOR_DEBT_DASHBOARD_DATA_LOAD,
        payload
    }
    return action;
}

function getEmployeeDashboardDataAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_EMPLOYEE_DASHBOARD_DATA_LOAD,
        payload
    }
    return action;
}

function getCustomDashboardDataAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_CUSTOM_DASHBOARD_DATA_LOAD,
        payload
    }
    return action;
}

function getFeedbackDashboardDataAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_FEEDBACK_DASHBOARD_DATA_LOAD,
        payload
    }
    return action;
}

function getFeedbackListAction(payload: any) {
    const action = {
        type: ApiConstants?.API_GET_FEEDBACK_LIST_LOAD,
        payload
    }
    return action;
}

function getFeedbackLocationsAction(payload?: any) {
    const action = {
        type: ApiConstants?.API_GET_FEEDBACK_LOCATIONS_LOAD,
        payload
    }
    return action;
}


export {
    getListAction,
    createCustomerAction,
    mergeCustomerAction,
    setCustomerCreditLimitAction,
    addCustomerCreditOpeningBalanceAction,
    recordCustomerCreditSettlementAction,
    getCustomerCreditLedgerAction,
    createCycleCountAction,
    updateProductItemColorAndSizeAction,
    addProductAction,
    categoryAndSubCategoryListAction,
    updateProductStatusAction,
    updateStickeringStatusAction,
    getProductListAction,
    getCustomerListAction,
    getReferenceDataAction,
    getUpcomingCustomerEventsAction,
    getProductItemAction,
    createBillAction,
    getBillingListAction,
    getBillNavigationRowAction,
    clearProductItemListAction,
    removedProductListAction,
    apparelLoginAction,
    sendLoginOtpAction,
    verifyLoginOtpAction,
    clearLoginOtpStateAction,
    getCustomerHistoryAction,
    getEmployeeSalesHistoryAction,
    getProductHistoryAction,
    getInvoiceDetailsAction,
    getBarcodeZipFile,
    updateMultipleInventoryAction,
    getMultipleInventoryCountsAction,
    getMultipleInventorySoldListAction,
    getMultipleInventoryDamagedListAction,
    createOrUpdateCycleCountAction,
    getCycleCountListAction,
    cycleCountListSearchAction,
    getCategorySubCategoryListAction,
    getProductListByCategory,
    getupdateCycleCountProductStatus,
    updateCycleCountAction,
    getMultipleInventoryScrapListAction,
    createBillV2Action,
    updateProductListAction,
    getCycleCountReportAction,
    getReportListAction,
    getVendorListAction,
    createOrUpdateVendorAction,
    getVendorEmailValidationAction,
    clearSelectAction,
    vendorDropDownListAction,
    getVendorPurchaseListAction,
    getRentalListAction,
    createOrUpdateRentalAction,
    createOrUpdateVendorPurchaseAction,
    getVendorPurchaseHistoryAction,
    getVendorDebtLedgerAction,
    createVendorDebtEntryAction,
    mrpListAction,
    getEmployeeListAction,
    createOrUpdateEmployeeAction,
    employeeDropDownListAction,
    createOrUpdateProcurementAction,
    createOrUpdateAttachmentAction,
    getAttachmentAction,
    getVendorBillAttachmentAction,
    getVendorDebtAttachmentAction,
    getProcurementAction,
    getProcurementExportListAction,
    getAuditLogListAction,
    getSalesReturnAction,
    createOrUpdateSalesReturnAction,
    getSalesReturnBasedOnProductIdAction,
    clearSalesReturnBasedOnProductIdAction,
    getSalesReturnBillDetailsAction,
    addCategoryAction,
    createOrUpdateBannerAction,
    getBannerMetaAction,
    getBannerAttachmentAction,
    addSubCategoryAction,
    getHotNewTopPickAction,
    updateHotNewTopPickAction,
    getOnlineOrderAction,
    updateOnlineOrderAction,
    getCoreCategoryMetaAction,
    updateItemQuantity,
    getDashboardDataAction,
    getTopProductsAction,
    getTopCustomersAction,
    getSalesDashboardDataAction,
    getInventoryDashboardDataAction,
    getCustomerDashboardDataAction,
    getVendorDashboardDataAction,
    getCustomerCreditDashboardDataAction,
    getVendorDebtDashboardDataAction,
    getCustomDashboardDataAction,
    getEmployeeDashboardDataAction,
    getStockHistoryAction,
    getStockMovementHistoryAction,
    adminAdjustStockAction,
    getComboComponentOptionsAction,
    getComboItemsAction,
    getAttendanceListAction,
    getEmployeeAttendanceCalendarAction,
    getEmployeeAttendanceSummaryAction,
    getAttendanceRecordByIdAction,
    markAttendanceAction,
    getFeedbackDashboardDataAction,
    getFeedbackListAction,
    getFeedbackLocationsAction
}
